<template>
  <div
    data-component="header"
    v-background-color="$store.getters['ui/getHeaderColor']"
  >
    <div
      v-if="backButton"
      data-element="nav-left"
      :data-visible="!!buttonText"
      @click="$router.go(-1)"
    >
      <p>{{ buttonText }}</p>
    </div>
    <router-link
      v-else
      data-element="nav-left"
      :to="buttonLink || ''"
      :data-visible="!!buttonText && !!buttonLink"
    >
      <p>{{ buttonText }}</p>
    </router-link>

    <router-link data-element="nav-center" to="/?reset=false">
      <img
        data-element="logo"
        :src="headerLogoUrl"
        :alt="$store.getters['getSite'].brandName"
      />
    </router-link>

    <router-link
      data-element="nav-right"
      to="/?reset=false"
      v-if="!collectOnly"
    >
      <p
        :data-visible="!!$store.getters['getTableNumber']"
        v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')"
        v-if="!hideTableNumber"
      >
        Table<br />{{ $store.getters["iOrderCore/getTableNumber"] }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["buttonText", "buttonLink", "hideTableNumber", "backButton"],
  computed: {
    site() {
      return this.$store.getters["getSite"];
    },
    collectOnly() {
      return this.site && this.site.collectOnly;
    },
    headerLogoUrl() {
      return (
        this.site &&
        this.site.headerLogo &&
        this.site.headerLogo.fields &&
        this.site.headerLogo.fields.file &&
        this.site.headerLogo.fields.file.url
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

[data-component="header"] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 0 8px;
  [data-element="nav-left"] {
    position: absolute;
    top: 8px;
    left: 8px;
    -webkit-tap-highlight-color: transparent;
    p {
      height: 40px;
      width: 62px;
      border-radius: 2px;
      background-color: rgba(255, 255, 255, 0.2);
      border: solid 1px white;
      color: white;
      text-align: center;
      font-size: 11px;
      line-height: 14px;
      padding: 0 10px;
      padding-top: 5px;
    }
  }
  [data-element="nav-left"],
  [data-element="nav-center"],
  [data-element="nav-right"] {
    &:focus {
      outline-color: #fff;
    }
  }
  [data-element="nav-left"] {
    visibility: hidden;
  }
  [data-element="nav-center"] {
    margin: 0 4px;
    margin-top: 4px;
    max-width: 50%;
    [data-element="logo"] {
      width: 100%;
    }
  }
  [data-element="nav-right"] {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 38px;
    height: 40px;
    p {
      color: white;
      text-align: center;
      font-size: 11px;
      line-height: 14px;
    }
  }
  [data-element="nav-right"],
  [data-element="nav-left"] {
    &[data-visible="true"] {
      visibility: visible;
    }
  }
}
</style>
